(function () {
  'use strict';

  var MEMBERSHIP_PRODUCT_ID = 9595798356226;

  function dedupeMemberships() {
    return fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart fetch failed with status ' + response.status);
        }
        return response.json();
      })
      .then(function (cart) {
        var membershipItems = cart.items.filter(function (item) {
          return item.product_id === MEMBERSHIP_PRODUCT_ID;
        });

        if (membershipItems.length <= 1) {
          return false;
        }

        var keep = membershipItems[membershipItems.length - 1];
        var toRemove = membershipItems.slice(0, -1);
        var updates = {};
        toRemove.forEach(function (item) {
          updates[item.key] = 0;
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Cart update failed with status ' + response.status);
            }
            return true;
          });
      });
  }

  function init() {
    if (window.fcMembershipGuardRan) {
      return;
    }
    window.fcMembershipGuardRan = true;

    dedupeMemberships()
      .then(function (didClean) {
        if (didClean) {
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('fc-membership-cart-guard: failed', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
